import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Support.css";
import Table from "../../../../../components/Table/Table";
import eyeOn from "../../../../../assets/tokens/eyeOn.png";
import userSupport from "../../../../../assets/user_support.png";
//services
import { supportService } from "../../../../../services/Support";
//utils
import { formatShortDate, formatTime } from "../../../../../utils/utils";

const Support = ({ user_id }) => {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [supportData, setSupportData] = useState([]);
  const [columns, setColumns] = useState([]);

  useEffect(() => {
    fetchColumns();
    fetchSupportData(currentPage);
  }, []);

  const fetchColumns = () => {
    const columnsData = [
      { header: "Support Folio", field: "id" },
      {
        header: "Contact Email",
        render: (row) => row.user.email,
      },
      {
        header: "Contact number",
        render: (row) => row.user.phone,
      },
      { header: "Reason", field: "reason" },
      { header: "Description", field: "description" },
      {
        header: "Date",
        render: (row) => formatShortDate(row.requested_at),
      },
      {
        header: "Time",
        render: (row) => formatTime(row.requested_at),
      },
      { header: "Status", field: "status" },
      {
        header: "",
        render: (row) => (
          <button className="view-btn" onClick={() => handleView(row)}>
            <img src={eyeOn} alt="View" />
          </button>
        ),
      },
      {
        header: "",
        render: (row) => (
          <button className="view-btn" onClick={() => handleAssign(row)}>
            <img src={userSupport} alt="View" />
          </button>
        ),
      },
      {
        header: "",
        render: (row) => (
          <button className="check-btn" onClick={() => handleCheck(row)}>
            Check
          </button>
        ),
      },
    ];

    setColumns(columnsData);
  };

  const fetchSupportData = async (page = 1) => {
    try {
      const params = {
        page: page,
        items_per_page: 10,
      };
      const response = await supportService.ticketsByUser(user_id, params);
      if (response.status === "success") {
        setSupportData(response.data.data || []);
        setTotalItems(response.data.total || 0);
      } else {
        setSupportData([]);
        setTotalItems(0);
      }
    } catch (error) {
      console.error("Error fetching support data:", error);
    }
  };

  const handleView = (row) => {
    console.log("View support:", row);
    // Implement view logic
    navigate(`/customers/support/${row.id}`, {
      state: {
        support: row,
        action: "view",
      },
    });
  };

  const handleAssign = (row) => {
    console.log("Assign support:", row);
    // Implement assign logic
    navigate(`/customers/support/${row.id}`, {
      state: {
        support: row,
        action: "assign",
      },
    });
  };

  const handleCheck = (row) => {
    console.log("Check support:", row);
    // Implement check logic
    navigate(`/customers/support/check/${row.id}`, {
      state: {
        support: row,
        action: "check",
      },
    });
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    fetchSupportData(page);
  };

  return (
    <div className="support-container">
      <div className="support-table">
        <Table
          columns={columns}
          data={supportData}
          currentPage={currentPage}
          totalItems={totalItems}
          itemsPerPage={10}
          onPageChange={handlePageChange}
          columnsShare={3}
        />
      </div>
    </div>
  );
};

export default Support;
